export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const formatCurrency = ( value ) => {
  const number = !isNaN(parseFloat( value )) && String( value ).trim() !== "" ? parseFloat( value ) : 0;
  return String( "$" + parseFloat( number ).toFixed( 2 ) ).replace( /(\d)(?=(\d{3})+(?!\d))/g, "$1," );
} //currencyFormat

export const formatCurrencyMoney = ( value ) => {
  const number = !isNaN(parseFloat( value )) && String( value ).trim() !== "" ? parseFloat( value ) : 0;
  return parseFloat( String( parseFloat( number ).toFixed( 2 ) ).replace( /(\d)(?=(\d{3})+(?!\d))/g, "$1," ));
} //currencyFormat

export function retardo(delay) {
  return new Promise( res => setTimeout(res, delay) );
}